import { DepositTransactionsPage } from 'features/transactions';

export const TechOperatorDepositTransactionsPage: React.FC = () => (
  <DepositTransactionsPage />
);
